"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalUploadSurvey = exports.ModalUploadType = exports.ModalUploadDoc = exports.ModalSuccess = exports.ModalConfirm = exports.ModalError = exports.ModalLog = exports.Tooltip = exports.Modal = void 0;
const tooltip_1 = __importDefault(require("./sub-components/tooltip"));
exports.Tooltip = tooltip_1.default;
const modal_log_1 = __importDefault(require("./sub-components/modal-log"));
exports.ModalLog = modal_log_1.default;
const modal_container_1 = __importDefault(require("./sub-components/modal.container"));
exports.Modal = modal_container_1.default;
const modal_error_1 = __importDefault(require("./sub-components/modal-error"));
exports.ModalError = modal_error_1.default;
const modal_confirm_1 = __importDefault(require("./sub-components/modal-confirm"));
exports.ModalConfirm = modal_confirm_1.default;
const modal_success_1 = __importDefault(require("./sub-components/modal-success"));
exports.ModalSuccess = modal_success_1.default;
const modal_upload_doc_1 = __importDefault(require("./sub-components/modal-upload-doc"));
exports.ModalUploadDoc = modal_upload_doc_1.default;
const modal_upload_type_1 = __importDefault(require("./sub-components/modal-upload-type"));
exports.ModalUploadType = modal_upload_type_1.default;
const modal_upload_survey_1 = __importDefault(require("./sub-components/modal-upload-survey"));
exports.ModalUploadSurvey = modal_upload_survey_1.default;
